<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Attributes />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Attributes from "../../components/Workflow/Definitions/Attributes.vue";
export default {
  components: { LandingToolbar, Attributes },
};
</script>
